<div class="mrf-confirm" role="alertdialog" aria-modal="true" [attr.aria-labelledby]="'mrf-confirm-title'">
  <div class="mrf-confirm__icon" aria-hidden="true">
    <i class="fa fa-exclamation-triangle"></i>
  </div>
  <h2 id="mrf-confirm-title" class="mrf-confirm__title">{{ title }}</h2>
  <p class="mrf-confirm__message">{{ data.message }}</p>
  <div class="mrf-confirm__actions">
    <button type="button" class="mrf-confirm__btn mrf-confirm__btn--no" (click)="onCancel()">
      {{ cancelLabel }}
    </button>
    <button type="button" class="mrf-confirm__btn mrf-confirm__btn--confirm" (click)="onConfirm()">
      {{ confirmLabel }}
    </button>
  </div>
</div>
